import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import Form from './Form';

const Contact = () => {
  return (
    <Container
      sx={{
        marginBottom: '100px',
      }}
    >
      <Grid container spacing={{ xs: 4, md: 8 }}>
        <Grid item xs={12} md={6}>
        <Box>
      <Box>
        <Box marginBottom={1}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
            }}
          >
            Ready to see it in action?
          </Typography>
        </Box>
        <Box>
          <Typography variant="h6" color={'text.secondary'}>
            Book a 30-minute demo and see how BridgeFirst fits your team's workflow — no commitment required.
          </Typography>
        </Box>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography 
            sx={{
              marginTop: '24px',
            }}
            variant={'subtitle1'}
          >
            sales@bridgefirstforecasting.com
          </Typography>
        </Grid>
      </Grid>
    </Box>
        </Grid>
        <Grid item container xs={12} md={6} alignItems={'center'}>
          <Form />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Contact;
